/* ARONA — măsurarea expunerii pe produs (P10.5) pentru Maison d'Esteban 3.0. Port din nubra-v2/theme/assets/arona-cx.js (Nubra live),
   adaptat markup-ului MES 3.0. ÎNLOCUIEȘTE est-track.js pe 3.0 (est-track.js nu se mai încarcă → o singură cale spre GA4, fără dubluri).
   Referința: _practici/TRACKING-CATALOG-ERP.md (§3 contractul, §10 nepotrivirile reparate aici).
   - est_list_impressions → GA4 view_item_list: carduri ≥ 50% vizibile ≥ 1 s, o dată per card per pagină, în loturi (10 / 5 s / ieșire)
   - est_select_item → GA4 select_item: click pe card (link spre produs), inclusiv produsele din mega-meniu (data-est-list)
   - est_view_item → GA4 est_view_item: pagina de produs + lista și poziția de origine (sessionStorage, 30 min)
   - est_add_to_cart → GA4 est_add_to_cart: sursa card / pdp / pdp_sticky (ERP-ul le știe doar pe acestea; restul = „card” + list_id propriu)
   - _arona_src pe coș: {variantă: [listă, poziție, sursă, ts]} → comanda (note_attributes) → ERP
   Publică ȘI în Shopify (Shopify.analytics.publish, pentru un eventual pixel) — pixelul „Arona Catalog” NU trebuie instalat pe Esteban (ar dubla GA4).
   GA4: ID din metafield-ul de magazin arona.ga4_measurement_id (rezervă: setarea temei „est_ga4_fallback”, goală). Fără ID → nimic spre GA4.
   Toate evenimentele au send_to = ID-ul GA4 (nu ajung la Google Ads / Merchant Center). Folosește gtag-ul aplicației Google dacă există.
   Trimite DOAR cu acord de analiză (Shopify Customer Privacy API); la retragerea acordului se oprește. Programat pe idle, fără task-uri lungi.
   Depanare: ?est_debug=1 (ținut în sesiune; ?est_debug=0 oprește) → consolă + debug_mode. */
(() => {
  if (window.__aronaCx) return;
  window.__aronaCx = true;
  window.__estTrack = true; /* est-track.js (dacă ar fi încărcat din greșeală) iese singur → fără dublură */
  const ctx = window.EST_CTX || {};
  try { const m = location.search.match(/[?&]est_debug=([01])/); if (m) sessionStorage.setItem('est_debug', m[1]); } catch (e) { /* privat */ }
  const debug = (() => { try { return sessionStorage.getItem('est_debug') === '1' || localStorage.getItem('est_debug') === '1'; } catch (e) { return /[?&]est_debug=1/.test(location.search); } })();
  const KEY = 'est_origin';
  const TTL = 30 * 60 * 1000;
  const idle = (fn, t = 1500) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: t }) : setTimeout(fn, 1));
  const num = (v) => { const n = Number(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : 0; };

  /* ---- GA4 direct, doar cu acord de analiză ---- */
  let GA4 = ctx.ga4 || '';
  if (!GA4) { try { GA4 = localStorage.getItem('arona_ga4_test') || ''; } catch (e) { /* privat */ } } /* doar pentru testul de pe previzualizare */
  let gaReady = false;
  const pending = [];
  const cp = () => window.Shopify?.customerPrivacy;
  const allowed = () => { try { return cp()?.analyticsProcessingAllowed?.() === true; } catch (e) { return false; } };
  const gtag = function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
  const send = (ev) => (typeof window.gtag === 'function' ? window.gtag : gtag)(...ev);
  const gaConfigured = () => !!window.google_tag_manager?.[GA4] || (window.dataLayer || []).some((x) => x && x[0] === 'config' && x[1] === GA4);
  const startGa = () => {
    if (gaReady || !GA4 || !allowed()) return;
    gaReady = true;
    if (!gaConfigured()) {
      /* aplicația Google n-a configurat ID-ul → îl încărcăm noi, fără page_view (paginile le numără deja aplicația) */
      const s = document.createElement('script');
      s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4}`;
      document.head.appendChild(s);
      gtag('js', new Date());
      gtag('config', GA4, debug ? { send_page_view: false, debug_mode: true } : { send_page_view: false });
    }
    pending.splice(0).forEach(send);
  };
  const onConsent = () => { if (allowed()) startGa(); else { pending.length = 0; } };
  document.addEventListener('visitorConsentCollected', onConsent);
  const loadCp = () => window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) onConsent(); });
  if (document.readyState === 'complete') idle(loadCp); else window.addEventListener('load', () => idle(loadCp), { once: true });

  const toGa = (name, d) => {
    if (!GA4) return;
    const it = (i) => ({ item_id: String(i.item_id || d.item_id || ''), item_name: i.item_name || d.item_name || '', index: num(i.index ?? d.index), price: num(i.price ?? d.price), item_list_id: d.list_id || '', item_list_name: d.list_name || '' });
    let ev = null;
    if (name === 'est_list_impressions') ev = ['event', 'view_item_list', { item_list_id: d.list_id, item_list_name: d.list_name, list_id: d.list_id, items: (d.items || []).map(it) }];
    else if (name === 'est_select_item') ev = ['event', 'select_item', { item_list_id: d.list_id, item_list_name: d.list_name, list_id: d.list_id, list_index: d.index, items: [it({})] }];
    else if (name === 'est_view_item') ev = ['event', 'est_view_item', { prod_id: String(d.item_id || ''), list_id: d.list_id, list_index: d.index, value: num(d.price), currency: 'RON' }];
    else if (name === 'est_add_to_cart') ev = ['event', 'est_add_to_cart', { prod_id: String(d.item_id || ''), list_id: d.list_id, list_index: d.index, atc_source: d.source, value: num(d.price) * num(d.quantity || 1), currency: 'RON' }];
    if (!ev) return;
    ev[2].send_to = GA4;
    if (debug) ev[2].debug_mode = true;
    if (gaReady) { if (allowed()) send(ev); return; } /* acord retras după pornire → nu mai pleacă nimic */
    if (pending.length < 50) pending.push(ev);
    if (allowed()) startGa();
  };

  const publish = (name, data) => {
    const payload = { ...data, page_type: ctx.tpl || '', site: ctx.shop || location.hostname };
    if (debug) console.log(`%c[arona-cx] ${name}`, 'color:#0a7', payload.items ? payload.items.map((i) => `${i.index}:${i.item_name}`).join(' · ') : `${payload.list_id || ''} #${payload.index || ''} ${payload.item_name || ''} ${payload.source || ''}`.trim(), payload);
    try { window.Shopify?.analytics?.publish?.(name, payload); } catch (e) { /* fără pixel = fără efect */ }
    toGa(name, payload);
  };
  window.AronaCX = { publish };

  /* ---- cardurile MES 3.0 ----
     .est-card[data-est-pid] = Card C (colecții, căutare, rândurile de pe home, recomandări), „Văzute recent”, cutiile video, finder / căutarea din antet;
     a[data-est-pid] = produsele din mega-meniu; [data-arona-card][data-product-id] = orice altă suprafață marcată explicit (seturi, fiole). */
  const CARD = '.est-card[data-est-pid], a[data-est-pid], [data-arona-card][data-product-id]';
  const pidOf = (c) => c.dataset.estPid || c.dataset.productId || '';
  const visible = (c) => c.offsetParent !== null || c.getClientRects().length > 0;
  const sectionOf = (el) => el.closest('.shopify-section, [id^="shopify-section-"]');
  /* 14 oct: o listă nu iese niciodată goală — atributul data-est-list gol e ignorat, iar rezultatul final are mereu o valoare
     (<template>:<secțiune>). Notă: „list_id = ''” din GA4 vine de la aplicația Google & YouTube (collection_viewed, ID-uri shopify_ZZ_…), nu de aici. */
  const listOf = (card) => {
    const l = listOf0(card);
    if (!l.id) l.id = `${ctx.tpl || 'page'}:${(sectionOf(card)?.id || '').split('__').pop().replace('shopify-section-', '') || 'other'}`;
    if (!l.name) l.name = l.id;
    return l;
  };
  const listOf0 = (card) => {
    const tagged = card.closest('[data-est-list]:not([data-est-list=""])');
    if (tagged) return { id: tagged.dataset.estList, name: tagged.closest('[data-est-list-name]')?.dataset.estListName || tagged.dataset.estListName || tagged.dataset.estList };
    if (card.closest('.search-inline, .search-panel, predictive-search-component, .predictive-search, .est-fi__list--hdr')) return { id: 'search_panel', name: 'Căutare rapidă' };
    if (card.closest('cart-drawer-component, .cart-drawer, .cart-items, [data-est-upsell]')) return { id: 'cart', name: 'Coș' };
    const sec = sectionOf(card);
    const raw = sec?.id || '';
    const key = raw.includes('__') ? raw.split('__').pop() : raw.replace('shopify-section-', '') || 'other';
    if (ctx.tpl === 'collection' && /main|product.grid|grid/.test(key)) return { id: `collection:${ctx.coll}`, name: ctx.collTitle || ctx.coll };
    if (ctx.tpl === 'search' && /main|search|result/.test(key)) return { id: 'search', name: `Căutare: ${ctx.search || ''}`.trim() };
    const heading = [...(sec?.querySelectorAll('h1, h2, h3, .h1, .h2, .h3') || [])].find((h) => !h.closest(CARD))?.textContent?.trim()?.replace(/\s+/g, ' ')?.slice(0, 80) || '';
    return { id: `${ctx.tpl || 'page'}:${key}`, name: heading || key };
  };
  const scopeOf = (card) => (card.parentElement || card).closest('[data-est-list-name], [data-est-list], .est-fi__list, cart-drawer-component, .cart-drawer') || sectionOf(card) || document.body;
  const infoOf = (card) => {
    const list = listOf(card);
    const lk = (c) => c.closest('[data-est-list]:not([data-est-list=""])')?.dataset.estList || '';
    const own = lk(card);
    const peers = [...scopeOf(card).querySelectorAll(CARD)].filter((c) => pidOf(c) && lk(c) === own && (c === card || visible(c)));
    const name = card.dataset.estName || card.dataset.aronaName || (card.querySelector('h3, [class*="title"], [class*="name"]')?.textContent || card.querySelector('img')?.alt || '');
    return {
      list_id: list.id, list_name: list.name, index: num(card.dataset.estIndex) || peers.indexOf(card) + 1,
      item_id: String(pidOf(card)), item_name: name.replace(/\s+/g, ' ').trim().split(',')[0].slice(0, 80),
      price: num(card.dataset.estPrice || card.dataset.price),
    };
  };
  const cardFrom = (el) => el?.closest?.(CARD) || el?.closest?.('product-card, .product-card, li, article')?.querySelector?.('.est-card[data-est-pid]') || null;

  /* ---- afișări ---- */
  const seen = new WeakSet();
  const timers = new WeakMap();
  let queue = [];
  const flush = () => {
    if (!queue.length) return;
    const byList = {};
    for (const it of queue) (byList[it.list_id] ||= { list_id: it.list_id, list_name: it.list_name, items: [] }).items.push({ item_id: it.item_id, item_name: it.item_name, index: it.index, price: it.price });
    queue = [];
    Object.values(byList).forEach((b) => publish('est_list_impressions', b));
  };
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const e of entries) {
      const card = e.target;
      if (seen.has(card)) continue;
      if (e.isIntersecting && e.intersectionRatio >= 0.5) {
        if (!timers.has(card)) timers.set(card, setTimeout(() => {
          seen.add(card); timers.delete(card); io.unobserve(card);
          idle(() => { queue.push(infoOf(card)); if (queue.length >= 10) flush(); }, 1000);
        }, 1000));
      } else if (timers.has(card)) { clearTimeout(timers.get(card)); timers.delete(card); }
    }
  }, { threshold: [0, 0.5] }) : null;
  const watched = new WeakSet();
  const watch = (root = document) => {
    if (!io) return;
    root.querySelectorAll(CARD).forEach((c) => { if (pidOf(c) && !watched.has(c)) { watched.add(c); io.observe(c); } });
  };
  setInterval(() => { if (queue.length) idle(flush); }, 5000);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);
  let pend = 0;
  new MutationObserver((muts) => {
    if (pend) return;
    for (const m of muts) if (m.addedNodes.length) { pend = setTimeout(() => { pend = 0; idle(() => watch()); }, 400); break; }
  }).observe(document.body, { childList: true, subtree: true });

  /* ---- click pe card → origine pentru pagina de produs ---- */
  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t || t.closest('[data-nb-add], button, quick-add-component')) return;
    const a = t.closest('a[href*="/products/"]');
    if (!a) return;
    const card = cardFrom(a);
    if (!card) return;
    const info = infoOf(card);
    try { sessionStorage.setItem(KEY, JSON.stringify({ pid: info.item_id, list_id: info.list_id, list_name: info.list_name, index: info.index, t: Date.now() })); } catch (err) { /* privat */ }
    publish('est_select_item', info);
  }, true);

  const origin = (pid) => {
    try {
      const o = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (o && String(o.pid) === String(pid) && Date.now() - o.t < TTL) return o;
    } catch (e) { /* privat */ }
    return null;
  };

  /* ---- pagina de produs (și setul de fiole) ---- */
  if (ctx.tpl === 'product' && ctx.pid) {
    const o = origin(ctx.pid);
    idle(() => publish('est_view_item', { item_id: String(ctx.pid), item_name: ctx.pname || '', price: num(ctx.price), list_id: o?.list_id || '(direct)', list_name: o?.list_name || '', index: o?.index || 0 }));
  }

  /* ---- _arona_src: un singur POST /cart/update.js per rafală de adăugări ---- */
  const SRC_KEY = 'arona_src';
  const of = window.fetch;
  let srcTimer = 0;
  const postSrc = () => {
    srcTimer = 0;
    let m = {};
    try { m = JSON.parse(sessionStorage.getItem(SRC_KEY) || '{}'); } catch (e) { m = {}; }
    const route = (window.Shopify?.routes?.root || '/') + 'cart/update.js';
    of.call(window, route, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _arona_src: JSON.stringify({ v: 1, i: m }) } }) }).catch(() => {});
  };
  const saveSrc = (variantIds, entry) => {
    if (!variantIds.length) return;
    let m = {};
    try { m = JSON.parse(sessionStorage.getItem(SRC_KEY) || '{}'); } catch (e) { m = {}; }
    variantIds.forEach((v) => { m[String(v)] = entry; });
    const keys = Object.keys(m);
    if (keys.length > 40) keys.sort((a, b) => (m[a][3] || 0) - (m[b][3] || 0)).slice(0, keys.length - 40).forEach((k) => delete m[k]);
    try { sessionStorage.setItem(SRC_KEY, JSON.stringify(m)); } catch (e) { /* privat */ }
    clearTimeout(srcTimer); srcTimer = setTimeout(postSrc, 300);
  };

  /* ---- adăugare în coș: evenimentul temei est:atc (card / pdp / pdp_sticky / kit) ---- */
  let estAtcSeen = 0;
  document.addEventListener('est:atc', (e) => {
    estAtcSeen = Date.now();
    const d = e.detail || {};
    let info = {};
    let source = d.source || 'other';
    const card = d.el ? cardFrom(d.el) : null;
    if (card) {
      info = infoOf(card);
      source = 'card';
    } else if (source === 'kit') {
      /* configuratorul 2+1 (bara de jos): ERP-ul nu știe sursa „kit” → „card” cu listă proprie */
      info = { list_id: 'kit_bar', list_name: 'Configurator 2+1', index: 0, item_id: String(d.productId || ''), item_name: d.name || '', price: num(d.price) };
      source = 'card';
    } else {
      const o = origin(d.productId);
      info = { list_id: o?.list_id || '(direct)', list_name: o?.list_name || '', index: o?.index || 0, item_id: String(d.productId || ''), item_name: d.name || '', price: num(d.price) };
      if (!/^(card|pdp|pdp_sticky)$/.test(source)) source = 'other';
    }
    if (!info.price && d.price) info.price = num(d.price);
    if (!info.item_name && d.name) info.item_name = d.name;
    const qty = (d.items || []).reduce((s, it) => s + (it.quantity || 0), 0) || 1;
    const ids = (d.items || []).map((it) => String(it.id));
    idle(() => {
      publish('est_add_to_cart', { ...info, item_id: info.item_id || String(d.productId || ''), source, quantity: qty });
      saveSrc(ids, [info.list_id || '(direct)', Number(info.index || 0), source, Math.floor(Date.now() / 1000)]);
    }, 1000);
  });

  /* ---- ATC generic (formulare / XHR / fetch din afara temei): doar dacă tema n-a emis est:atc pentru aceeași cerere ---- */
  let lastTarget = null;
  document.addEventListener('pointerdown', (e) => { lastTarget = e.target instanceof Element ? e.target : null; }, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') lastTarget = document.activeElement; }, true);
  document.addEventListener('submit', (e) => { lastTarget = e.submitter || e.target; }, true);
  const parseBody = (body) => {
    const out = { ids: [], qty: 0 };
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        const id = body.get('id'); if (id) out.ids.push(String(id));
        out.qty = Number(body.get('quantity') || 1);
        return out;
      }
      const b = typeof body === 'string' ? JSON.parse(body || '{}') : body || {};
      (b.items || [b]).forEach((it) => { if (it && it.id) out.ids.push(String(it.id)); out.qty += Number(it?.quantity || 1); });
    } catch (e) { /* corp necunoscut */ }
    if (!out.qty) out.qty = 1;
    return out;
  };
  const onAdded = (tgt, body, t0) => {
    /* temele emit est:atc DUPĂ ce citesc coșul → așteptăm 2,5 s; dacă a venit est:atc după începutul cererii, nu numărăm a doua oară */
    setTimeout(() => {
      if (estAtcSeen >= t0) return;
      const { ids, qty } = parseBody(body);
      const card = cardFrom(tgt);
      let info; let source;
      if (card) { info = infoOf(card); source = 'card'; }
      else if (ctx.tpl === 'product' && ctx.pid) {
        const o = origin(ctx.pid);
        info = { item_id: String(ctx.pid), item_name: ctx.pname || '', price: num(ctx.price), list_id: o?.list_id || '(direct)', list_name: o?.list_name || '', index: o?.index || 0 };
        source = tgt?.closest?.('[class*="sticky"], [class*="sbar"]') ? 'pdp_sticky' : 'pdp';
      } else {
        info = { item_id: '', list_id: tgt?.closest?.('cart-drawer-component, .cart-drawer, [class*="cart"]') ? 'cart' : '(other)', list_name: '', index: 0 };
        source = 'other';
      }
      idle(() => {
        publish('est_add_to_cart', { ...info, source, quantity: qty });
        saveSrc(ids, [info.list_id || '(direct)', Number(info.index || 0), source, Math.floor(Date.now() / 1000)]);
      });
    }, 2500);
  };
  const isAdd = (url) => /\/cart\/add(\.js)?(\?|$)/.test(url || '');
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const p = of.apply(this, arguments);
    if (isAdd(url)) {
      const tgt = lastTarget; const t0 = Date.now();
      p.then((r) => { if (r.ok) onAdded(tgt, init?.body, t0); }).catch(() => {});
    }
    return p;
  };
  const xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__aronaAdd = isAdd(String(url)); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__aronaAdd) { const tgt = lastTarget; const t0 = Date.now(); this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) onAdded(tgt, body, t0); }); }
    return xs.apply(this, arguments);
  };

  /* butoanele PDP / prelander: est:cta → est_cta_click (doar în Shopify; nemapat spre GA4, ca înainte) */
  document.addEventListener('est:cta', (e) => {
    const d = e.detail || {};
    try { window.Shopify?.analytics?.publish?.('est_cta_click', { cta: d.cta || '', item_id: String(d.productId || ''), item_name: d.name || '', page_type: ctx.tpl || '', site: ctx.shop || location.hostname }); } catch (err) { /* - */ }
  });

  const start = () => idle(() => watch(), 2000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
